import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchQuery, SearchResultsPayload } from 'src/app/state-management';

@Component({
    selector: 'app-saved-search-list',
    templateUrl: './saved-search-list.component.html',
    styleUrls: ['./saved-search-list.component.scss'],
    standalone: false
})
export class SavedSearchListComponent implements OnInit {
  @Input() searchQueries$: Observable<SearchQuery[]>;
  @Output() querySelector = new EventEmitter<SearchResultsPayload>();
  @Output() queryDeleter = new EventEmitter<SearchQuery>();

  private ngUnsubscribe: Subject<void> = new Subject();
  savedQueries: SearchQuery[] = [];

  constructor() {}
  ngOnInit() {
    this.searchQueries$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(results => {
        // sort query names to appear in name sorted order
        this.savedQueries = results.sort((queryA, queryB) => {
          if (queryA.savedQueryName < queryB.savedQueryName) { return -1; }
          if (queryA.savedQueryName > queryB.savedQueryName) { return 1; }
          return 0;
        });
      });
  }

  handleQuerySelect(savedQuery: SearchQuery) {
    const { savedQueryName: string, ...searchResults } = savedQuery;
    this.querySelector.emit(searchResults);
  }

  handleQueryDelete(savedQuery: SearchQuery) {
    this.queryDeleter.emit(savedQuery);
  }
}
